// Central place for role-name checks.
//
// The `Super Admin` role was added after most of these gates were written, so
// anything comparing against the bare string 'Admin' silently excluded it.
// Use these helpers instead of hardcoding role names.

export const ADMIN_ROLE = 'Admin';
export const SUPER_ADMIN_ROLE = 'Super Admin';
export const PROJECT_MANAGER_ROLE = 'Project Manager';

const roleOf = (user) => user?.user_roles?.role;

// Admin-level: full administrative rights (Admin and Super Admin).
export const isAdminLevel = (role) => [ADMIN_ROLE, SUPER_ADMIN_ROLE].includes(role);

// Roles that see every supervisor's data instead of only their own.
export const seesAllRecords = (role) =>
  [ADMIN_ROLE, SUPER_ADMIN_ROLE, PROJECT_MANAGER_ROLE].includes(role);

// Super Admin only. Used for the user-edit/delete approval queue, which the
// backend also restricts to this role — do not widen it to `isAdminLevel`.
export const isSuperAdmin = (role) => role === SUPER_ADMIN_ROLE;

// Same checks, taking the user object straight from the redux store.
export const isAdminLevelUser = (user) => isAdminLevel(roleOf(user));
export const seesAllRecordsUser = (user) => seesAllRecords(roleOf(user));
export const isSuperAdminUser = (user) => isSuperAdmin(roleOf(user));
